export class Address {
    public id: number;
    public name: string;
    public address: string;
    public number: number;
    public complement: string;
    public zipcode: string;
    public city: string;
    public state: string;
    public updated: Date;

    constructor() {
        this.id = 0;
    }
}